// src/components/Hero.js
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  VStack,
  HStack,
  Tag,
  Circle,
  Icon,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link as ScrollLink } from 'react-scroll'; // <<< 1. IMPORT SCROLL LINK
import { Link as RouterLink } from 'react-router-dom';

import heroImage from '../assets/hero_image.png';

export default function Hero() {
  return (
    <Flex
      direction={{ base: 'column', lg: 'row' }}
      maxW="7xl"
      mx="auto"
      py={{ base: 12, md: 24 }}
      px={8}
      align="center"
      id="home"
    >
      {/* Left Side: Text Content */}
      <VStack
        align={{ base: 'center', lg: 'flex-start' }}
        textAlign={{ base: 'center', lg: 'left' }}
        spacing={6}
        flex="1"
        maxW={{ lg: '50%' }}
      >
        <Text color="orange.500" fontWeight="bold">Award-Winning Construction Excellence</Text>
        <Heading as="h1" size={{ base: '2xl', md: '3xl' }} fontWeight="extrabold">
          Where Innovation Drives <br />
          <Text as="span" color="orange.500">Structural Perfection</Text>
        </Heading>
        <Text color="gray.600" fontSize="lg">
        Our commitment to superior craftsmanship and client satisfaction is at the core of every project we undertake, from blueprint to completion.
        </Text>
        <HStack wrap="wrap" justify={{ base: 'center', lg: 'flex-start' }}>
          <Tag size="lg" variant="outline" m={1}>General Construction Services</Tag>
          <Tag size="lg" colorScheme="gray" m={1}>Concrete Work</Tag>
          <Tag size="lg" variant="outline" m={1}>Design and Planning</Tag>
          <Tag size="lg" variant="outline" m={1}>Civil Works</Tag>
          <Tag size="lg" variant="outline" m={1}>Pre-Construction</Tag>
        </HStack>
      </VStack>

      {/* Right Side: Image and Stats */}
      <Flex
        flex="1"
        justify="center"
        align="center"
        position="relative"
        mt={{ base: 10, lg: 0 }}
      >
        <Image
          src={heroImage}
          alt="Construction workers looking at a blueprint"
          borderRadius="lg"
          boxShadow="2xl"
          objectFit="cover"
        />
        <Box
          position="absolute"
          bottom="-50px"
          right={{ base: '0', md: '20px' }}
          bg="orange.500"
          color="white"
          p={8}
          borderRadius="lg"
          textAlign="center"
          boxShadow="xl"
        >
          <VStack spacing={4}>
            <Box>
              <Text fontSize="4xl" fontWeight="bold">50+</Text>
              <Text>Projects Completed</Text>
            </Box>
            <Box>
              <Text fontSize="4xl" fontWeight="bold">15+</Text>
              <Text>Years of Experience</Text>
            </Box>
            <Box>
              <Text fontSize="4xl" fontWeight="bold">48+</Text>
              <Text>Happy Customers</Text>
            </Box>
          </VStack>
        </Box>
        
        {/* "Get in Touch" Circle --- UPDATED --- */}
        <Circle
          // Use ScrollLink as the component
            // Add ScrollLink props
            as={RouterLink}
            to="/contact"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            // Add Circle styling props
            size="100px"
            bg="blue.900"
            color="white"
            position="absolute"
            top="-30px"
            left={{ base: 'auto', md: '-50px' }}
            right={{base: '10px', md: 'auto'}}
            boxShadow="lg"
            display="flex"
            flexDirection="column"
            textAlign="center"
            p={2}
            cursor="pointer" // Add pointer cursor on hover
        >
            <Text fontSize="sm" lineHeight="1">GET IN</Text>
            <Icon as={ArrowForwardIcon} w={6} h={6} transform="rotate(45deg)" />
            <Text fontSize="sm" lineHeight="1">TOUCH</Text>
        </Circle>
      </Flex>
    </Flex>
  );
}